<template lang="pug">
.social-icons-list
  a.social-icons-list__item(
    v-for="social in socialIconsList",
    :key="social.type",
    :class="getClassType(social.type)"
    :href="social.link",
    target="_blank"
  )
    icon.social-icons-list__icon(group="social", :name="social.type")
</template>

<script>
export default {
  name: "SocialIconsListDumb",
  props: {
    theme: {
      type: String,
      default: "black", // black, white
    },

    // [{type: "discord", link: "https://blabla.tm"}, {...}, ...]
    socialIconsList: {
      type: [Array, Object],
      required: true,
    },
  },
  methods: {
    getClassType(name) {
      return [`social-icons-list__item--${this.theme}`, `social-icons-list__item--${name}`];
    },
  },
}
</script>

<style lang="scss">
  @import "../styles/social-icons-list";
</style>
